import gql from "graphql-tag";

export default {
  searchSubjects: gql`
    query searchSubjects($search: String!, $first: Int, $schemeId: String) {
      subjects(first: $first, simplesearch: $search, subjectScheme_id: $schemeId) {
        edges {
          node {
            id
            _id
            heading
            code
            notes
            subjectScheme {
              id
              heading
            }
          }
        }
      }
    }
  `
};
